<template>
  <section>
    <div class="columns is-centered">
      <div class="column is-12 no-padding-mobile">
        <div class="section no-padding-mobile">
          <div class="container no-padding-mobile">
            <h1 class="title" style="padding-left: 20px;">
              <a
                @click="
                  $router.push({
                    name: 'onBoard.neofintech.myNeofintechRequests'
                  })
                "
                ><b-icon
                  pack="fas"
                  size="is-small"
                  icon="arrow-Detalles básicosft"
                >
                </b-icon
              ></a>
              &nbsp; {{ $t('Solicitud') }}
            </h1>
            <b-loading
              :is-full-page="true"
              :active.sync="isLoading"
              :can-cancel="false"
            ></b-loading>
            <div class="request-detail-tabs no-padding-mobile">
              <b-tabs position="is-centered" type="is-toggle">
                <b-tab-item
                  icon-pack="fas"
                  icon="stream"
                  :label="$t('Timeline')"
                >
                  <request-timeline
                    :rol="'client'"
                    @newMessage="submitNewMessage"
                    :requestData="requestData"
                    :events="timelineEvents"
                    class="no-padding-mobile"
                  />
                </b-tab-item>
                <b-tab-item icon-pack="fas" icon="file" :label="$t('Archivos')">
                  <request-files :files="requestFiles" />
                </b-tab-item>
                <b-tab-item
                  icon-pack="fas"
                  icon="info-circle"
                  :label="$t('Detalles')"
                >
                  <request-data-form :id="id" />
                </b-tab-item>
              </b-tabs>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapActions } from 'vuex'
import Fetcher from '@/mixins/fetcher.js'
import RequestTimeline from '@/components/on-board/RequestTimeline'
import RequestFiles from '@/components/on-board/RequestFiles'
import RequestDataForm from '@/components/forms/RequestDataForm'
import Pusher from 'pusher-js'

export default {
  data() {
    return {
      timelineEvents: [],
      requestFiles: [],
      requestData: {
        status: null,
        email: null,
        phase: null,
        updatedAt: null
      }
    }
  },
  props: ['id'],
  mixins: [Fetcher],
  components: { RequestTimeline, RequestDataForm, RequestFiles },
  computed: {},
  mounted() {
    let self = this
    self.loadRequestData()
    let pusher = new Pusher('936ddb2d71afd002b5d0', {
      cluster: 'eu',
      forceTLS: true
    })

    let channel = pusher.subscribe(self.id)
    channel.bind('timeline-event', function(newEvent) {
      self.timelineEvents.push({
        eventType: newEvent.SK.split('|')[0],
        timestamp: newEvent.timestamp,
        source: newEvent.GSI1SK.split('|')[0],
        content: newEvent.content,
        link: newEvent.link,
        title: newEvent.title
      })
    })
  },
  methods: {
    ...mapActions('onBoard', [
      'getOnboardRequestTimelineEvents',
      'getOnboardRequestDetails',
      'postNewOnboardRequestMessage',
      'getOnboardRequestFiles'
    ]),
    submitNewMessage: function(data) {
      let self = this
      self.request(() =>
        self.postNewOnboardRequestMessage({
          data: data,
          requestId: self.id
        })
      )
    },
    loadRequestData: function() {
      let self = this
      self.request(() =>
        self.getOnboardRequestDetails(self.id).then(function(response) {
          self.requestData = response.data
        })
      )
      self.request(() =>
        self.getOnboardRequestFiles(self.id).then(function(response) {
          self.requestFiles = response.data
        })
      )
      self.request(() =>
        self.getOnboardRequestTimelineEvents(self.id).then(function(response) {
          const timelineEvents = response.data.map(function(elem) {
            return {
              eventType: elem.SK.split('|')[0],
              timestamp: elem.timestamp,
              source: elem.GSI1SK.split('|')[0],
              content: elem.content,
              link: elem.link,
              title: elem.title
            }
          })
          self.timelineEvents = timelineEvents
        })
      )
    }
  }
}
</script>

<style scoped>
.request-detail-tabs {
  background: white;
  padding: 10px;
  border-radius: 8px;
  border: solid 1px #de4281;
}
</style>
